import { render, staticRenderFns } from "./simDetail.vue?vue&type=template&id=d6a1549c"
import script from "./simDetail.vue?vue&type=script&lang=js"
export * from "./simDetail.vue?vue&type=script&lang=js"
import style0 from "./simDetail.vue?vue&type=style&index=0&id=d6a1549c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports